import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast } from "../../../components/toast/Toasts";

export const getAllActivityLogs = createAsyncThunk(
  "GiftCode/GetActivityLogs",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/GetActivityLogs`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
